import {FileState} from "./interface/fileInterface"
import {Action} from "./interface/baseInterface"
const fileState = {
    new: {
        baseInfo: {
            name: "",
            type: "",
            url: "",
            status: "waiting",
            hasData: false,
            tempFileId: "",
        },
        compareInfo: {
            name: "",
            type: "",
            url: "",
            status: "waiting",
            hasData: false,
            tempFileId: "",
        },
    },
    last: {
        baseInfo: {
            name: "",
            type: "",
            url: "",
            status: "waiting",
            hasData: false,
            tempFileId: "",
        },
        compareInfo: {
            name: "",
            type: "",
            url: "",
            status: "waiting",
            hasData: false,
            tempFileId: "",
        },
    },
    display: {
        baseInfo: {
            name: "",
            type: "",
            url: "",
            status: "waiting",
            hasData: false,
            tempFileId: "",
        },
        compareInfo: {
            name: "",
            type: "",
            url: "",
            status: "waiting",
            hasData: false,
            tempFileId: "",
        },
    },
}

export const fileReducer = (state: FileState = fileState, action: Action) => {
    const payload = action.payload
    switch (action.type) {
        case "TDAInit": {
            return {
                ...fileState,
            }
        }
        case "replaceNew":
            return {
                ...state,
                new: {
                    ...state.new,
                    baseInfo: payload.baseInfo,
                    compareInfo: payload.compareInfo,
                },
            }
        case "replaceNewBase":
            return {
                ...state,
                new: {
                    ...state.new,
                    baseInfo: payload,
                },
            }
        case "replaceNewBaseAfterValid":
            return {
                ...state,
                new: {
                    ...state.new,
                    baseInfo: {
                        ...state.new.baseInfo,
                        ...payload,
                    },
                },
            }
        case "replaceNewCompare":
            return {
                ...state,
                new: {
                    ...state.new,
                    compareInfo: payload,
                },
            }
        case "replaceNewCompareAfterValid":
            return {
                ...state,
                new: {
                    ...state.new,
                    compareInfo: {
                        ...state.new.compareInfo,
                        ...payload,
                    },
                },
            }
        case "fileNewToDisplayAndLast":
            return {
                ...state,
                display: {
                    ...state.new,
                },
                last: {
                    ...state.new,
                },
            }
        case "replaceDisplay":
            return {
                ...state,
                display: payload,
            }
        default:
            return {...state}
    }
}
